<template>
  <div class="Hero">
    <div class="layout center-layout">
      <div class="container">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "Hero"
};
</script>
<style lang="less">
  @import "~@root/less/func/variables";
  @import "~@root/less/func/elements";

  .Hero {
    height: 350px;
    width: 100%;
    position: relative;
    margin-bottom: 20px;
    background-repeat: no-repeat;
    background-size: cover;
    &:after {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgb(0, 0, 0);
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.25) 100%
      );
    }
    .container{
      height: 350px;
      position: relative;
    }

    @media (min-width: @bootstrap-md) {
      height: 500px;
      .container{
        height: 500px;
      }
    }
    > .layout{
      position: static;
    }

    .logo {
        position: absolute;
        z-index: 3;
        left: 0;
        bottom: -20px;
        width: 160px;
        height: 160px;
        background: @white;
        border: 3px solid @white;
        .drop-shadow(0, 1px, 6px, .15);
        .box-sizing();

        @media @mq_ml
        {
            width: 120px;
            height: 120px;
        }
    }

    .info {
      position: absolute;
      z-index: 3;
      left: 190px;
      right: 0;
      bottom: 25px;
      color: @white;

      @media @mq_ml {
        left: 145px;
        bottom: 15px;
      }

      @media @mq_mp {
        left: 135px;
      }
    }

    .info-edit{
      @media @mq_sd{
        padding-right: 40px;
      }

      @media @mq_mp{
        bottom: -138px;
        left: 0;
        padding-right: 0;

        .badge
        {
            color: @gray2;
        }
      }
    }

    .badge {
      font-size: 13px;

      @media (min-width: @bootstrap-md) {
        font-size: 16px;
      }
    }

    .name{
      font-size: 24px;
      font-weight: @Semibold;
      line-height: 1.2;
      @media (min-width: @bootstrap-md){
        font-size: 32px;
      }
      @media (min-width: @bootstrap-lg){
        font-size: 38px;
      }
    }
  }
</style>
